<template>
  <Row>
    <Col span="24">
    <Card>
      <p slot="title">访视列表</p>
      <span slot="extra">
        <Select v-model="status" style="width:120px" @on-change="fetchData" placeholder="请选择状态" clearable>
          <Option v-for="(status,key) in statuses" :value="key" :key="key">{{ status }}</Option>
        </Select>
        <Input v-model="queryStr" placeholder="请输入关键词查询" @on-change="fetchData" style="width: 300px"></Input>
        <Button type="success" @click="showAdd = true"><Icon type="plus"></Icon> 添加</Button>
      </span>
      <Table stripe :columns="attributes" :data="visits" v-if="visits">
        <template slot-scope="{ row }" slot="baseline">
            <span v-if="row.baseline">
              <Tag color="success">是</Tag>
            </span>
        </template>
        <template slot-scope="{ row }" slot="window">
            <span v-if="row.visit_at !== null">
              {{ row.visit_at }} ( {{ row.lower }} ~ {{ row.upper }} ) 天
            </span>
        </template>
      </Table>
      <pagination v-bind:meta="pageMeta" name="pagination" @refresh="fetchData"></pagination>
    </Card>
    <Modal
        v-model="showAdd"
        title="添加访视"
        :styles="{bottom:'0px'}" >
        <add-visit ref="addVisit" @refresh="refresh"></add-visit>
        <div slot="footer" v-show="false"></div>
    </Modal>
    <Modal
        v-model="showEdit"
        title="编辑访视信息"
        :styles="{bottom:'0px'}" >
        <edit-visit ref="editVisit" :meta="meta" @refresh="refresh"></edit-visit>
        <div slot="footer" v-show="false"></div>
    </Modal>
    </Col>
  </Row>
</template>

<script>
import { ListVisits, DeleteVisit } from '@/api/visit'
import AddVisit from '@/components/visit/AddVisit'
import EditVisit from '@/components/visit/EditVisit'
import Pagination from '@/components/share/Pagination'

export default {
  name: 'list-visits',
  data: function () {
    return {
      visits: [],
      queryStr: '',
      meta: '',
      showAdd: false,
      showEdit: false,
      pageMeta: {},
      status: '1',
      statuses: {
        '1': '激活',
        '0': '禁用'
      },
      attributes: [{
        title: '序号',
        key: 'order',
        sortable: true
      },
      {
        title: '访视',
        key: 'visit',
        sortable: true
      },
      {
        title: '访视点',
        key: 'visit_at',
        sortable: true
      },
      {
        title: '基线',
        key: 'baseline',
        sortable: true,
        slot: 'baseline'
      },
      {
        title: '访视窗',
        key: 'visit_at',
        slot: 'window'
      },
      {
        title: '状态',
        key: 'statusText'
      },
      {
        title: '操作',
        key: 'action',
        width: 120,
        render: (h, params) => {
          const icon = params.row.status === 1 ? 'ios-trash' : 'ios-refresh'
          return h('div', [
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: 'ios-create-outline'
              },
              on: {
                click: () => {
                  this.edit(params.row.id)
                }
              }
            }),
            h('Button', {
              props: {
                type: 'text',
                size: 'small',
                icon: icon
              },
              on: {
                click: () => {
                  this.remove(params.row.id)
                }
              }
            })
          ])
        }
      }]
    }
  },
  components: {
    'pagination': Pagination,
    'add-visit': AddVisit,
    'edit-visit': EditVisit
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function (page = 1) {
      var query = this.$router.currentRoute.query
      query['page'] = page
      query['VisitSearch[status]'] = this.status
      query['VisitSearch[studyid]'] = this.$route.params.id
      query['queryStr'] = this.queryStr
      ListVisits(query).then(async res => {
        this.visits = res.items
        this.pageMeta = res._meta
      })
    },
    refresh: function () {
      this.fetchData()
      this.showAdd = false
      this.showEdit = false
    },
    edit: function (id) {
      this.meta = id
      this.$refs.editVisit.init(id)
      this.showEdit = true
    },
    remove: function (id) {
      DeleteVisit(id).then(async res => {
        this.refresh()
      })
    }
  }
}
</script>
